import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { Router } from "@angular/router";
import { MenuServiceSelectorService } from "./menuServiceSelector.service";
import { Subscription } from "rxjs";
import { CoreLogService } from "../../services/log.service";
import { SnackBarService, } from "../../services/snackBar.service";
import { orderTypes, VoucherServiceType } from "../../shared/contentTypes";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { trigger, transition, query, style, stagger, animate } from "@angular/animations";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { Location } from "@angular/common";
import { OrdertypeViewModel } from "../../shared/models";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { LocationService } from "../location/location.service";

@Component({
  selector: "menu-service-selector",
  templateUrl: "./menuServiceSelector.component.html",
  providers: [MenuServiceSelectorService],
  styleUrls: ["./menuServiceSelector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("serviceButtonEntering", [
      transition("* => *", [
        query(".choice", [
          style({ transform: "scale(0)" }),
          stagger(100, [
            animate("400ms ease-out", style({ transform: "scale(1.1)" })),
            animate("100ms ease-in-out", style({ transform: "scale(1)" }))
          ])
        ], { optional: true })
      ])
    ]),
  ]
})
export class MenuServiceSelectorComponent implements OnInit, OnDestroy {

  private enabledVoucherCharge: boolean = false;

  public WebShopMode = WebShopMode;
  public isSmallView: boolean = false;
  //public ordertypes$: Observable<OrdertypeViewModel[]>;
  public ordertypes: OrdertypeViewModel[];
  private _ordertypesChangesSubscriber: Subscription;

  constructor(private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _coreLogService: CoreLogService
    , private _webShopService: WebShopService
    , private _snackBarService: SnackBarService
    , private _location: Location
    , private _locationService: LocationService
    , private _menuServiceSelectorService: MenuServiceSelectorService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , _mainnavService: MainnavService) {
    this.isSmallView = _mainnavService.viewType === ViewType.Small;
    this._changeDetectorRef.detach();
  }

  private PushChanges(): void {
    try {
      if (!this._changeDetectorRef['destroyed']) {
        this._changeDetectorRef.detectChanges();
      }
    } catch (e) {
      this._coreLogService.error("MenuServiceSelectorComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me._menuServiceSelectorService.getIsVoucherChargeEnabled().then((isVoucherChargeEnabled) => {
      // achtung dies kann gefährlich sein, da nicht darauf gewartet wird, wenn es ausgewärtet wird
      me.enabledVoucherCharge = isVoucherChargeEnabled;
    });

    me._ordertypesChangesSubscriber = me._menuServiceSelectorService.getSupportServices$.subscribe((ordertypes) => {
      // Leifer- und Abholungsgruppen werden nicht als selbständigen Service angeboten
      me.ordertypes = ordertypes.filter(ordertype => ordertype.id !== orderTypes.deliveryGroup && ordertype.id !== orderTypes.pickupGroup);
      me.PushChanges();
    });
    // PushChanges nur im _ordertypesChangesSubscriber da die einzigen elemente sind die dargestellt werden müssen
  }

  ngOnDestroy() {
    const me = this;
    if (me._ordertypesChangesSubscriber) {
      me._ordertypesChangesSubscriber.unsubscribe();
    }
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me._location.back();
    }
  }

  public checkService(mode: WebShopMode) {
    const me = this;
    const serviceID = me._webShopService.getServiceMode();
    const isRemoteOrder = serviceID === WebShopMode.DeliveryGroup || serviceID === WebShopMode.PickupGroup
    if (isRemoteOrder && me._remoteGroupOrderService.groupId !== 0) {
      me._webShopService.openWarningLeaveGroup(me._webShopService.locationID, mode)
    } else {
      me._webShopService.openWarningResetBasketDialogIfNeed(me._webShopService.locationID, mode, (agree) => {
        if (agree) {
          me.setService(mode);
        } /* else do nothing */
      });
    }

  }

  /**initilize service; use seperate initialization for voucher service */
  private setService(mode: WebShopMode) {
    const me = this;
    if (mode === WebShopMode.Webvoucher) {
      me.intializeVoucherService();
    } else {
      me.initializeService(mode);
    }
  }
  /**initialize service for voucher */
  private async intializeVoucherService(): Promise<void> {
    const me = this;
    let serviceMode: WebShopMode;
    const mode = WebShopMode.Webvoucher;
    if (me.enabledVoucherCharge) {
      serviceMode = await me._webShopService.setServiceMode(mode, true, me._webShopService.voucherServiceType);
      me._router.navigate(["/vouchercredit"]);
    } else {
      serviceMode = await me._webShopService.setServiceMode(mode, true, VoucherServiceType.Order);
      me._webShopService.HasSingleLocation(mode)
        .then(response => {
          if (response) {
            me._webShopService.tryAndRouteToSingleVariableWebvoucher();
          } else {
            me._router.navigate(["/menulocation"]);
          }
        })
        .catch(e => {
          me._coreLogService.error("MenuServiceSelectorComponent.intializeVoucherService", "_webShopService.HasSingleLocation", e);
          me._snackBarService.ShowErrorMessageFailed(68);
        });
    }
  }

  /**initalize service instead of voucher service */
  // ! TODO funktion identisch mit home.component.ts
  private async initializeService(mode: WebShopMode) {
    const me = this;
    let serviceMode: WebShopMode;
    serviceMode = await me._webShopService.setServiceMode(mode);
    if (serviceMode != null) {
      if (mode === me.WebShopMode.OrderToTable) {
        me._router.navigate(["/qrcodescanner"]);
      } else if (mode === me.WebShopMode.TakeAway || mode === me.WebShopMode.Ticket || mode === me.WebShopMode.Retail || mode === me.WebShopMode.Viewing) {
        me._webShopService.HasSingleLocation(mode)
          .then(response => {
            me.handleNavigateSingleLocation(response, mode);
          })
          .catch(e => {
            me._coreLogService.error("MenuServiceSelectorComponent.initializeService", "_webShopService.HasSingleLocation", e);
            me._snackBarService.ShowErrorMessageFailed(69);
          });
      } else {
        //delivery
        me.WebShopMode.Delivery ? me._router.navigate(["/orderAddressQuery"]) : me._router.navigate(["/menulocation"]);
      }
    } else {
      me._coreLogService.error("MenuServiceSelectorComponent.initializeService", "serviceMode invalid/null", serviceMode);
      me._snackBarService.ShowErrorMessageFailed(70);
    }
  }

  private handleNavigateSingleLocation(hasSingleLocation: boolean, mode: WebShopMode) {
    const me = this;
    if (hasSingleLocation) {
      if (mode === me.WebShopMode.TakeAway) {
        me.initializeServiceTimeSelectionOptions(mode);
        // viewing, ticket, retail
      } else {
        me._router.navigate(["/menugroup"]);
      }
    } else {
      //select location
      me._router.navigate(["/menulocation"]);
    }
  }

  private async initializeServiceTimeSelectionOptions(serviceMode: WebShopMode) {
    const me = this;
    const location = await me._locationService.GetWebshopLocationInfoViewModel(serviceMode, me._webShopService.locationID);
    await me._webShopService.initializeAndProcessServiceTime({
      serviceMode: serviceMode,
      location: location,
    });
  }

}

